import {
    Grid, Box, Typography, Select, MenuItem, InputLabel,
    FormControl, Paper, Card, CardContent, Divider
} from '@mui/material';




import CommonList from '../CommonList';




function ProjectMgmt() {

    return (
        <Grid item xs={12} md={6}>
            <Card elevation={3}>
                <CardContent>


                    <CommonList
                        mode={2}
                        mainUrl="api/project-management/projects"
                        mainKey="organization_project_id"
                        gridKey="Projects_grid_dashboard"
                        heading="Project Reports"
                          route="/project"
                        btnName={null}
                        sortName="Last_Task_Update"
                    />


                </CardContent>
            </Card>
        </Grid>
    )

}

export default ProjectMgmt

